/* eslint-disable react/prop-types */
import CreateAnnouncement from "../index";

function InitAnnoucement({ startAnnoucement }) {
  return <CreateAnnouncement startAnnoucement={startAnnoucement} />;
}

export default InitAnnoucement;
